import React from "react";
import gql from "graphql-tag";
import { useQuery } from "@apollo/react-hooks";
import TopbarViewerActions from "components/TopbarViewerActions";
import AccountMenu from "components/AccountMenu";
import { isSessionActive } from "lib/currentUser/session";

export const VIEWER_QUERY = gql`
  query viewer {
    viewer { role, user { id, avatar, name, newsFeedCount } }
  }
`;

export default () => {
  if (isSessionActive()) {
    const { loading, error, data } = useQuery(VIEWER_QUERY);

    if (loading) { return null; }
    if (error) { return null; }

    const role = data.viewer.role;
    const user = data.viewer.user;

    return (
      <React.Fragment>
        <AccountMenu role={role} user={user} />
        <TopbarViewerActions role={role} user={user} />
      </React.Fragment>
    );
  }

  return (
    <TopbarViewerActions />
  );
};
